import React from 'react';
import { StyledButton } from './GhostButton.styled';
import { Loading } from './../../../../common/Icons/Loading';
import { BodyM, BodySSemiBold, BodyMSemiBold } from './../../../../common/typography/typography';
import { IGhostButtonProps } from './../../../../common/interfaces/buttons';
import { buttonsVariantSize } from './../../../../common/styles/variants/variants';
import { defaultTheme } from './../../../../common/styles/theme/default';

function renderTitle(
  title: string,
  size: string,
  isDisabled: boolean,
  isLoading: boolean,
  variant: 'default' | 'fuchsia',
  primaryText?: boolean
) {
  if (variant === 'fuchsia') {
    const titleColor =
      isDisabled || isLoading
        ? defaultTheme.textColor.tertiary
        : primaryText
          ? defaultTheme.textColor.primary
          : defaultTheme.colors.fuchsia[600];
    return <BodyM style={{ color: titleColor }}>{title}</BodyM>;
  }

  const color = isDisabled || isLoading ? 'tertiary' : 'link';

  switch (size) {
    case 'l':
      return <BodyMSemiBold color={color}>{title}</BodyMSemiBold>;
    default:
      return <BodySSemiBold color={color}>{title}</BodySSemiBold>;
  }
}

export function GhostButton({
  title,
  onClick,
  isLoading = false,
  isDisabled = false,
  leftIcon,
  rightIcon,
  size = 's',
  variant = 'default',
  primaryText = false,
  ...rest
}: IGhostButtonProps) {
  if (isDisabled || isLoading) {
    return (
      <StyledButton
        onClick={onClick}
        isLoading={isLoading}
        padding={variant === 'fuchsia' ? '0' : buttonsVariantSize[size].padding}
        borderRadius={buttonsVariantSize[size].borderRadius}
        ghostVariant={variant}
        {...rest}
      >
        {isLoading ? (
          <Loading />
        ) : (
          <>
            {leftIcon && leftIcon}
            {title && renderTitle(title, size, isDisabled, isLoading, variant, primaryText)}
            {rightIcon && rightIcon}
          </>
        )}
      </StyledButton>
    );
  }

  return (
    <StyledButton
      onClick={onClick}
      isLoading={isLoading}
      padding={variant === 'fuchsia' ? '0' : buttonsVariantSize[size].padding}
      borderRadius={buttonsVariantSize[size].borderRadius}
      ghostVariant={variant}
      {...rest}
    >
      {isLoading ? (
        <Loading />
      ) : (
        <>
          {leftIcon && leftIcon}
          {title && renderTitle(title, size, isDisabled, isLoading, variant, primaryText)}
          {rightIcon && rightIcon}
        </>
      )}
    </StyledButton>
  );
}
